module.exports = __webpack_public_path__ + "static/StyreneA-Regular-d11c2a1804604cd5cdb1bf923a7b170f.woff2";